// FCM 토큰 관리 유틸리티

const FCM_TOKEN_KEY = 'fcmToken'

/**
 * FCM 토큰 저장
 */
export const saveFcmToken = (token: string): void => {
  if (token) {
    localStorage.setItem(FCM_TOKEN_KEY, token)
  }
}

/**
 * FCM 토큰 가져오기
 */
export const getFcmToken = (): string | null => {
  return localStorage.getItem(FCM_TOKEN_KEY)
}

/**
 * FCM 토큰 삭제
 */
export const clearFcmToken = (): void => {
  localStorage.removeItem(FCM_TOKEN_KEY)
}

/**
 * FCM 토큰 존재 여부 확인
 */
export const hasFcmToken = (): boolean => {
  return !!getFcmToken()
}
